export type PulseEventName =
  | 'chat_started'
  | 'first_question_shown'
  | 'question_answered'
  | 'survey_completed'
  | 'signup_completed'
  | 'login_succeeded'
  | 'shortlist_viewed'
  | 'trial_card_opened'
  | 'b2b_page_viewed'
  | 'b2b_page_left'
  | 'b2b_action';

export interface ChatStartedProps {
  entrypoint?: string;
}
export interface FirstQuestionShownProps {
  entrypoint?: string;
}
// No questionId: question text/translationKeys are disease-inferential, so the client
// never populates it. The key stays in PULSE_TAXONOMY below to mirror the backend
// allow-list (pinned by the drift test), but no client call can carry it.
export interface QuestionAnsweredProps {
  answerType?: string;
  positionInFlow?: number;
  timeSpentMs?: number;
}
export interface SurveyCompletedProps {
  questionCount?: number;
  timeSpentMs?: number;
}
export interface SignupCompletedProps {
  method?: string;
}
export interface LoginSucceededProps {
  method?: string;
}
export interface ShortlistViewedProps {
  trialCount?: number;
}
export interface TrialCardOpenedProps {
  positionInList?: number;
  trialId?: string;
}

// Route and identity context stamped on every B2B event. `trialId` is the internal uuid.
export interface B2BContextProps {
  page?: string;
  section?: string;
  subTab?: string;
  tab?: string;
  teamId?: string;
  trialId?: string;
  userRole?: string;
}
export interface B2BPageViewedProps extends B2BContextProps {
  pageViewId?: string;
}
export interface B2BPageLeftProps extends B2BPageViewedProps {
  activeMs?: number;
}
export interface B2BActionProps extends B2BContextProps {
  action: string;
  detail?: string;
  targetId?: string;
}

export interface PulseEventPropsMap {
  b2b_action: B2BActionProps;
  b2b_page_left: B2BPageLeftProps;
  b2b_page_viewed: B2BPageViewedProps;
  chat_started: ChatStartedProps;
  first_question_shown: FirstQuestionShownProps;
  login_succeeded: LoginSucceededProps;
  question_answered: QuestionAnsweredProps;
  shortlist_viewed: ShortlistViewedProps;
  signup_completed: SignupCompletedProps;
  survey_completed: SurveyCompletedProps;
  trial_card_opened: TrialCardOpenedProps;
}

const B2B_CONTEXT_KEYS = ['section', 'page', 'tab', 'subTab', 'trialId', 'userRole', 'teamId'];

// Allowed prop keys per event — mirrors the backend EVENT_REGISTRY. The drift
// test asserts this matches the backend exactly.
export const PULSE_TAXONOMY: Record<PulseEventName, readonly string[]> = {
  chat_started: ['entrypoint'],
  first_question_shown: ['entrypoint'],
  question_answered: ['questionId', 'answerType', 'positionInFlow', 'timeSpentMs'],
  survey_completed: ['questionCount', 'timeSpentMs'],
  signup_completed: ['method'],
  login_succeeded: ['method'],
  shortlist_viewed: ['trialCount'],
  trial_card_opened: ['trialId', 'positionInList'],
  b2b_page_viewed: [...B2B_CONTEXT_KEYS, 'pageViewId'],
  b2b_page_left: [...B2B_CONTEXT_KEYS, 'pageViewId', 'activeMs'],
  b2b_action: [...B2B_CONTEXT_KEYS, 'action', 'detail', 'targetId'],
};
